import React from "react";

const TabletStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 4.93103C3 3.86455 3.86455 3 4.93103 3H15.069C16.1355 3 17 3.86455 17 4.93103V15.069C17 16.1355 16.1355 17 15.069 17H4.93103C3.86455 17 3 16.1355 3 15.069V4.93103Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 14H10",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TabletStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;